import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);
Vue.http.options.root = `${window.location.origin}/api/v1`;

export default Vue.resource;



// WEBPACK FOOTER //
// ./app/javascript/packs/auctions_catalogs/show/resources/base.js